import { HttpContextToken, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { CacheService } from "../../services/cache/cache.service";
import { of, tap } from "rxjs";
import { environment } from "../../../environments/environment";

const ENDPOINTS_TO_CACHE = ["gateCatalogItem", "asset", "tenant", "auth", "software"];

export const REFERSH = new HttpContextToken<boolean>(() => false);

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
  const refresh = req.context.get(REFERSH);
  const baseUrl = extractBaseUrl(req.urlWithParams);

  const reqUrl = req.urlWithParams;
  if (req.method !== "GET") return next(req);

  if (baseUrl) {
    const endpoint = extractEndpoint(reqUrl, baseUrl);

    if (ENDPOINTS_TO_CACHE.includes(endpoint) || isSvg(reqUrl)) {
      const cache = inject(CacheService);
      const cachedResponse = cache.get(req.urlWithParams);
      return cachedResponse && !refresh
        ? of(
            new HttpResponse({
              body: cachedResponse.body,
              status: 200,
            })
          )
        : setResponseInCache(req, next);
    } else {
      return next(req);
    }
  } else {
    return next(req);
  }
};

const isSvg = (url: string) => {
  return url.endsWith(".svg");
};

const extractBaseUrl = (url: string) => {
  if (url.includes(environment.deviceManagementUrl)) {
    return environment.deviceManagementUrl;
  } else if (url.includes(environment.baseUrlV2)) {
    return environment.baseUrlV2;
  } else if (url.includes(environment.baseUrl)) {
    return environment.baseUrl;
  } else if (url.includes("assets/icons")) {
    return "assets/icons";
  } else return null;
};

const extractEndpoint = (url: string, baseUrl: string) => {
  const endpointWithParams = url.split(baseUrl)[1];
  let endpoint;
  if (endpointWithParams.includes("?")) {
    endpoint = endpointWithParams.split("?")[0].split("/")[1];
  } else {
    endpoint = endpointWithParams.split("/")[1];
  }
  return endpoint;
};

const setResponseInCache = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const cache = inject(CacheService);

  // Optimization: When a article call is being saved delete the cache for all articles. This is because you can call this endpoint wihtout parent and it returns all articles.
  //maybe call this function (delete) when changes are being made to articles and not here
  if (req.urlWithParams.includes("ARTICLE")) {
    cache.delete(environment.baseUrl + "/gateCatalogItem?catalogType=ARTICLE");
  }
  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        cache.set(req.urlWithParams, event);
      }
    })
  );
};
